// ===== PRODUCT CARD — carousel + click behavior (Shopify version) =====

function carouselSetIndex(card, index) {
  const dots = card.querySelectorAll('.carousel-dot');
  const total = dots.length;
  if (!total) return;
  const nextIndex = ((index % total) + total) % total;
  card.querySelector('.carousel-track').style.transform = `translateX(-${nextIndex * 100}%)`;
  dots.forEach((d, i) => d.classList.toggle('active', i === nextIndex));
}

function carouselGetIndex(card) {
  return Array.from(card.querySelectorAll('.carousel-dot')).findIndex(dot => dot.classList.contains('active'));
}

function initProductCarousels() {
  document.querySelectorAll('.product-image.carousel').forEach(card => {
    if (card.dataset.carouselInit) return;
    card.dataset.carouselInit = '1';

    const total = card.querySelectorAll('.carousel-slide').length;
    if (total < 2) return;

    let timer = null;
    let current = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let didSwipe = false;
    let suppressClick = false;

    const syncCurrent = () => {
      const activeIndex = carouselGetIndex(card);
      current = activeIndex >= 0 ? activeIndex : current;
      return current;
    };

    const showNext = (delta = 1) => {
      current = syncCurrent() + delta;
      carouselSetIndex(card, current);
    };

    card.addEventListener('mouseenter', () => {
      timer = setInterval(() => showNext(1), 900);
    });

    card.addEventListener('mouseleave', () => {
      clearInterval(timer);
      timer = null;
      current = 0;
      carouselSetIndex(card, 0);
    });

    card.querySelectorAll('.carousel-dot').forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        const index = parseInt(dot.dataset.index, 10);
        carouselSetIndex(card, index);
      });
    });

    card.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      didSwipe = false;
    }, { passive: true });

    card.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      const dx = touch.clientX - touchStartX;
      const dy = touch.clientY - touchStartY;
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
        didSwipe = true;
        e.preventDefault();
      }
    }, { passive: false });

    card.addEventListener('touchend', (e) => {
      if (!didSwipe) return;
      const touch = e.changedTouches[0];
      const dx = touch.clientX - touchStartX;
      const dy = touch.clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        e.stopPropagation();
        suppressClick = true;
        showNext(dx < 0 ? 1 : -1);
        window.setTimeout(() => { suppressClick = false; }, 250);
      }
    });

    card.addEventListener('click', (e) => {
      if (e.target.closest('.carousel-dot')) return;
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      e.stopPropagation();
      if (!suppressClick) showNext(1);
      suppressClick = false;
    });
  });
}

// Whole-card click navigates to product page (except clicks on interactive elements)
function initProductCardClicks() {
  document.querySelectorAll('.product-card[data-product-url]').forEach(card => {
    if (card.dataset.clickInit) return;
    card.dataset.clickInit = '1';
    card.style.cursor = 'pointer';

    card.addEventListener('click', (e) => {
      if (e.target.closest('.carousel-dot, .add-to-cart, form, button, a')) return;
      window.location.href = card.dataset.productUrl;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductCarousels();
  initProductCardClicks();

  if (typeof window.onProductsLoaded === 'function') {
    window.onProductsLoaded();
  }
});